import React from 'react';

import { IIconProps } from '@icons/icons.types';
import { TIconType } from '@icons/interface';

const FavoriteIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='18'
			viewBox='0 0 18 18'
			width='18'
			{...props?.innerSvgProps}
		>
			<path
				d='M9.29613 13.6537L12.6882 15.89C13.1257 16.1765 13.6641 15.7502 13.5362 15.2261L12.5536 11.2149C12.527 11.1037 12.5312 10.987 12.5658 10.8781C12.6003 10.7693 12.6637 10.6729 12.7488 10.5999L15.7908 7.96533C16.1879 7.62291 15.986 6.93108 15.4678 6.89614L11.4969 6.63058C11.3886 6.62404 11.2844 6.58486 11.1972 6.51785C11.1099 6.45083 11.0434 6.35888 11.0056 6.25322L9.52496 2.38175C9.48577 2.26987 9.41437 2.17322 9.32045 2.10493C9.22654 2.03663 9.11466 2 9 2C8.88534 2 8.77346 2.03663 8.67955 2.10493C8.58563 2.17322 8.51423 2.26987 8.47504 2.38175L6.99438 6.25322C6.95664 6.35888 6.89008 6.45083 6.80283 6.51785C6.71558 6.58486 6.61142 6.62404 6.50307 6.63058L2.53221 6.89614C2.01398 6.93108 1.81208 7.62291 2.20916 7.96533L5.25124 10.5999C5.33627 10.6729 5.3997 10.7693 5.43423 10.8781C5.46876 10.987 5.47299 11.1037 5.44642 11.2149L4.43688 15.0933C4.28208 15.7223 4.92819 16.2324 5.44642 15.89L8.70387 13.6537C8.79238 13.5953 8.89511 13.5643 9 13.5643C9.10489 13.5643 9.20762 13.5953 9.29613 13.6537Z'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
				{...props ? { fill: 'currentColor' } : {}}
			/>
		</svg>
	);
};

export default FavoriteIcon;
